module.exports = __webpack_public_path__ + "img/case45-jpg.14ab40eb.jpg";